import { useCallback } from 'react';
import { AccountMgtSvcClient, AccountMgtSvcClientV3 } from '@jarvis/web-stratus-client';
import { useApiCall, useRootContext } from '@jarvis/react-portal-addons';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function useDevicesProgramInfoApiCall() {
  const { stack, shell } = useRootContext();

  const {
    orgSelector, authProvider,
  } = shell;

  const flags = useFlags();

  const {
    grantsSupport,
  } = flags;

  const apiCall = useCallback(async ({ devices }) => {
    const SvcClient = grantsSupport ? AccountMgtSvcClientV3 : AccountMgtSvcClient;
    const client = new SvcClient(stack, authProvider);

    const deviceInfos = Promise.all(
      devices.map(async device => {
        try {
          const deviceProgramInfosResponse = await client.getDeviceProgramInfos(
            orgSelector.getOrgTenantId(),
            device.deviceId,
          );

          return {
            ...device,
            programInfo: deviceProgramInfosResponse?.data?.programInfo,
          };
        } catch {
          return null;
        }
      }),
    );

    return deviceInfos.then(infos => infos.filter(Boolean));
  }, [authProvider, grantsSupport, orgSelector, stack]);

  return useApiCall({
    apiCall,
    init: false,
  });
}
